import {
  instance as axios,
  setJwtToken,
} from "./../config/axiosInstance";
// Get analytics logs with filters
export const getAnalyticsLogsApi = async (params = {}) => {
  try {
    const response = await axios.get("/admin/analytics/logs", {
      params,
      ...setJwtToken(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get analytics summary
export const getAnalyticsSummaryApi = async (params = {}) => {
  try {
    const response = await axios.get("/admin/analytics/summary", {
      params,
      ...setJwtToken(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get analytics log by ID
export const getAnalyticsLogByIdApi = async (id) => {
  try {
    const response = await axios.get(`/admin/analytics/logs/${id}`, {
      ...setJwtToken(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get unique user IDs
export const getUniqueUsersApi = async (params = {}) => {
  try {
    const response = await axios.get("/admin/analytics/unique-users", {
      params,
      ...setJwtToken(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get unique devices (for anonymous logs)
export const getUniqueDevicesApi = async (params = {}) => {
  try {
    const response = await axios.get("/admin/analytics/unique-devices", {
      params,
      ...setJwtToken(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get user analytics
export const getUserAnalyticsApi = async (userId, params = {}) => {
  try {
    const response = await axios.get(`/admin/analytics/user/${userId}`, {
      params,
      ...setJwtToken(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get device analytics (for anonymous logs)
export const getDeviceAnalyticsApi = async (deviceId, params = {}) => {
  try {
    const response = await axios.get(`/admin/analytics/device/${deviceId}`, {
      params,
      ...setJwtToken(),
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Export analytics logs
export const exportAnalyticsLogsApi = async (params = {}) => {
  try {
        const response = await axios.get("/admin/analytics/export", {
      params,
      ...setJwtToken(),
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

